export default __webpack_public_path__ + "static/media/chain.0a577796.jpg";